module.exports = "<h2 class=\"page-header\">Emails</h2>\n<div class=\"clear\"></div>\n<itpx-dynamic-grid [fields]=\"fields\" [url]=\"url\"></itpx-dynamic-grid>"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/communication/emails/components/emails.component.html
// module id = ./src/app/organization/components/communication/emails/components/emails.component.html
// module chunks = main